import { render, staticRenderFns } from "./UploadedImg.vue?vue&type=template&id=99643188&scoped=true&"
import script from "./UploadedImg.vue?vue&type=script&lang=js&"
export * from "./UploadedImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadedImg.vue?vue&type=style&index=0&id=99643188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99643188",
  null
  
)

export default component.exports